import { Stack, Box, Typography } from "@mui/material"
import { useTBContext } from "../../Tournament Builder/Contexts/useTBStates";

interface MenuSpanHeaderProps {
  matchName: string;
  label: string;
  defaultPanel: string;
  /** When provided, active state requires viewPanel === panelMatch as well as appSection === matchName */
  panelMatch?: string;
  /** When provided, clicking sets groupTypeFilter to this value and active state requires groupTypeFilter === groupFilter */
  groupFilter?: string;
}

const MenuSpanHeader = ({ matchName, label, defaultPanel, panelMatch, groupFilter }: MenuSpanHeaderProps) => {

    const {
      appSection, setAppSection,
      editMode,
      setViewEvent, setEventTabValue,
      viewPanel, setViewPanel,
      setViewGroup,
      groupTypeFilter, setGroupTypeFilter,
    } = useTBContext();

    const isActive = (() => {
      if (appSection !== matchName) return false;
      if (groupFilter !== undefined) return groupTypeFilter === groupFilter;
      if (panelMatch !== undefined) return viewPanel === panelMatch;
      return true;
    })();

  return (
    <Stack direction={'row'} spacing={2} alignItems={'center'} padding={'3px 1px'}
        onClick={() => {
          if (!editMode) {
            const leavingGroups = appSection === 'groups' && matchName !== 'groups';
            const goingToCommandCenter = matchName === 'commandCenter';
            setAppSection(matchName);
            setViewPanel(defaultPanel);
            if (matchName === 'groups') {
              setViewGroup(null);
              setGroupTypeFilter((groupFilter as any) ?? 'all');
            } else if (matchName !== 'commandCenter') {
              // Keep viewGroup when entering Command Center so breadcrumbs
              // can link back to the collection; clear it for every other dest.
              setViewGroup(null);
            }
            // Keep viewEvent when moving into Command Center (including from a
            // collection event) so it stays auto-selected. Reset the event when
            // opening any collections sidebar page, leaving collections for
            // somewhere other than Command Center, or going to Overview.
            const leavingEventSection = !['tournaments', 'commandCenter', 'groups'].includes(matchName);
            const resettingGroups = matchName === 'groups';
            const leavingGroupsDroppingEvent = leavingGroups && !goingToCommandCenter;
            const goingToOverview = matchName === 'tournaments' && defaultPanel === 'snapshot';
            if (leavingEventSection || resettingGroups || leavingGroupsDroppingEvent || goingToOverview) {
              setViewEvent(null);
              setEventTabValue(0);
            }
          }
        }}
        sx={{ 
          backgroundColor: isActive ? 'sepia.extraLight' : 'transparent', borderRadius: 1,
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)'
        }, cursor: 'pointer' }}
    >
       <Box sx={{ backgroundColor: isActive ? 'sepia.main' : 'transparent',
           width: 5, height: 20, borderRadius: 1}} />
        <Typography variant='subtitle2' color='sepia.main'>{label}</Typography>
    </Stack>
  )
}

export default MenuSpanHeader;
